import { render, staticRenderFns } from "./Updown.vue?vue&type=template&id=1ffe3847&"
import script from "./Updown.vue?vue&type=script&lang=js&"
export * from "./Updown.vue?vue&type=script&lang=js&"
import style0 from "./Updown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports